import wbtcIcon from "../../../media/icons/wbtc.png";

export function WBTCIcon() {
    return (
        <img src={wbtcIcon} width={40} height={40} alt='WBTC'/>
    )
}
